<template>
   <div class="wrapper">
      <CRow class="mt-3">
         <CCol sm="4">
            <CCard>
               <CCardHeader><b> Schedule Form </b> </CCardHeader>
               <CCardBody>
                  <div>
                     <CRow>
                        <CCol sm="12">
                           <b> Class Template List </b>
                           <model-select
                              v-model="form.template_id"
                              :options="options_class"
                           ></model-select>
                        </CCol>
                     </CRow>
                     <CRow class="mt-3">
                        <CCol>
                           <b> <label> Description </label> </b>
                           <c-textarea
                              v-model="form.description"
                              placeholder="Description"
                              rows="10"
                              class="mb-1"
                           >
                           </c-textarea>
                        </CCol>
                     </CRow>
                  </div>
               </CCardBody>
            </CCard>
         </CCol>

         <CCol sm="8">
            <div>
               <CCard>
                  <CCardBody>
                     <CRow>
                        <CCol sm="4">
                           <label> <b> Max Number of Student </b> </label>
                           <b-input v-model="form.max"> </b-input>
                        </CCol>
                     </CRow>
                     <CRow class="mt-3">
                        <CCol sm="4">
                           <b> Assign teacher </b>
                           <model-select
                              v-model="form.teacher"
                              :options="options"
                           ></model-select>
                        </CCol>
                     </CRow>
                     <CRow class="mt-3">
                        <CCol sm="4">
                           <label> <b> Datetime Publish </b></label>
                           <datetime
                              class="animated-placeholder"
                              format="YYYY-MM-DD H:i:s"
                              width="100%"
                              readonly
                              v-model="form.publish_date"
                           ></datetime>
                        </CCol>
                     </CRow>
                     <CRow class="mt-3">
                        <CCol sm="4">
                           <label> <b> Datetime Class </b></label>
                           <datetime
                              class="animated-placeholder"
                              format="YYYY-MM-DD H:i:s"
                              width="100%"
                              readonly
                              v-model="form.class_date"
                           ></datetime>
                        </CCol>
                     </CRow>
                     <CRow class="mt-3">
                        <CCol sm="4">
                           <label> <b> Link </b> </label>
                           <b-input
                              v-model="form.link"
                              :state="validationName"
                              id="feedback-user"
                           >
                           </b-input>
                        </CCol>
                     </CRow>
                     <CRow class="mt-3">
                        <CCol sm="4">
                           <label> <b> Location </b> </label>
                           <b-input
                              v-model="form.location"
                              :state="validationName"
                              id="feedback-user"
                           >
                           </b-input>
                        </CCol>
                     </CRow>
                  </CCardBody>
               </CCard>
               <CButton
                  v-if="btn_create"
                  block
                  type="submit"
                  v-on:click.prevent="create()"
                  color="info"
                  ><b>Create </b></CButton
               >
               <CButton
                  v-if="btn_update"
                  block
                  type="submit"
                  v-on:click.prevent="update(form.id)"
                  color="info"
                  >Update</CButton
               >
               <CButton
                  v-if="btn_create || btn_update"
                  block
                  type="submit"
                  v-on:click.prevent="back()"
                  color="warning"
                  ><b>Back to Schedule </b></CButton
               >
            </div>
         </CCol>
      </CRow>

      <!-- <pre> {{ $data | json }} </pre> -->

      <alertmodal></alertmodal>
   </div>
</template>

<script>
import datetime from "vuejs-datetimepicker";
import classschedule from "@/services/class_schedule";
import classtemplate from "@/services/class_template";
import alertmodal from "@/views/alert/modal.vue";
import EventBus from "@/eventBus";

import people from "@/services/people";
import _ from "lodash";
import { ModelSelect } from "vue-search-select";

export default {
   name: "Dashboard",
   components: {
      alertmodal,
      datetime,
      ModelSelect,
   },
   data() {
      return {
         btn_create: 0,
         btn_update: 0,
         form: {
            id: "",
            template_id: "",
            description: "",
            teacher: "",
            publish_date: "",
            class_date: "",
            location: "",
            link: "",
            max: "",
         },
         options: [],
         options_class: [],
      };
   },

   mounted() {
      this.loadData();
      EventBus.$on("TABLE_UPDATE", (data) => {
         if (data) {
            this.loadData();
         }
      });
   },

   created() {},

   beforeDestroy() {
      // removing eventBus listener
      EventBus.$off("TABLE_UPDATE");
   },

   methods: {
      loadData() {
         if (this.$route.query.id) {
            this.btn_update = 1;

            classschedule
               .getSchedulebyID(this.$route.query.id)
               .then((res) => {
                  this.form.id = res.data.id;
                  this.form.template_id = res.data.template_id;
                  this.form.description = res.data.description;
                  this.form.class_date = res.data.class_date;
                  this.form.publish_date = res.data.publish_date;
                  this.form.location = res.data.location;
                  this.form.link = res.data.link;
                  this.form.teacher = res.data.teacher;
                  this.form.max = res.data.max;
               })
               .catch((err) => {
                  var params = {
                     title: "Error",
                     mode: "danger",
                     data: err.response.data.message,
                  };
                  EventBus.$emit("OPEN_MODAL_ALERT", params);
               });
         } else {
            this.btn_create = 1;
         }
         this.options = [];
         this.options_class = [];

         classschedule.getTeacher().then((res) => {
            for (let i = 0; i <= res.teacher.length - 1; i++) {
               this.options.push({
                  text: res.teacher[i].firstname + " " + res.teacher[i].lastname,
                  value: res.teacher[i].uuid,
               });
            }
         });
         classtemplate.getTemplate().then((res) => {
            for (let i = 0; i <= res.data.length - 1; i++) {
               //alert
               this.options_class.push({
                  text: res.data[i].name,
                  value: res.data[i].id,
               });
            }
         });
      },
      create() {
         classschedule
            .createSchedule(this.form)
            .then((res) => {
               var params = {
                  title: "Success",
                  mode: "success",
                  data: res.message,
               };
               EventBus.$emit("OPEN_MODAL_ALERT", params);
               setTimeout(() => {
                  this.$router.push({ name: "Schedule" });
               }, 1500);
            })
            .catch((err) => {
               var params = {
                  title: "Error",
                  mode: "danger",
                  data: err.response.data.message,
               };
               EventBus.$emit("OPEN_MODAL_ALERT", params);
            });
      },

      timeout(ms) {
         //pass a time in milliseconds to this function
         return new Promise((resolve) => setTimeout(resolve, ms));
      },

      update(id) {
         this.show = false;
         classschedule
            .updateSchedule(id, this.form)
            .then((res) => {
               var params = {
                  title: "Success",
                  mode: "success",
                  data: res.message,
               };
               EventBus.$emit("OPEN_MODAL_ALERT", params);
               setTimeout(() => {
                  this.$router.push({ name: "Schedule" });
               }, 1500);
            })
            .catch((err) => {
               var params = {
                  title: "Error",
                  mode: "danger",
                  data: err.response.data.message,
               };
               EventBus.$emit("OPEN_MODAL_ALERT", params);
            });
      },
      back: function(id) {
         this.$router.push({ name: "Schedule" });
      },
      getImage(url) {
         if (url) {
            //url = url.replace('https://x.ifgfsby.org','http://localhost:8005');
            return url;
         } else {
            return "";
         }
      },
      openModalPhotoBGImage(id) {
         var params = { title: "Update BG Image", mode: "edit", data: id };
         EventBus.$emit("OPEN_MODAL_EVENT_PHOTO_BGIMAGE", params);
         console.log("load modal photo");
      },
      openModalPhotoBannerImage(id) {
         var params = { title: "Update Banner Image", mode: "edit", data: id };
         EventBus.$emit("OPEN_MODAL_EVENT_PHOTO_BANNERIMAGE", params);
         console.log("load modal photo");
      },
      getPhoto(data) {
         console.log("get - photo");
         if (data) {
            return (
               axios.defaults.baseURL +
               "/getfile/" +
               data.path +
               "/" +
               data.filename
            );
         } else {
            return axios.defaults.baseURL + "/getfile/memberphoto/no_photo.jpg";
         }
      },
   },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
